<template>
  <div>
    <div class="row text-white inner-row" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.name + '(' + fieldView(object.code) + ')'}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>

    <simple-row :name="'Наименование'" :value="fieldView(object.name)"></simple-row>
    <simple-row :name="'Актикул'" :value="fieldView(object.code)"></simple-row>
    <simple-row :name="'Категория'" :value="object.category ? fieldView(object.category.name) : '-'"></simple-row>
    <simple-row v-if="object.maxLoad" :name="'Максимальный вес пациента, кг'" :value="fieldView(object.maxLoad)"></simple-row>
    <simple-row v-if="object.buildHeight" :name="'Строительная высота, мм'" :value="fieldView(object.buildHeight)"></simple-row>
    <simple-row :name="'Стоимость, руб.'" :value="object.price ? fieldView(object.price) : 'Нет данных'"></simple-row>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       showCalls: false,
       showIPRs: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     }
   }
 }
</script>
<style>
</style>
